import ApiUtils from "../ApiUtils";

export default class ApiReportService {

    async getAssignmentReport(classId) {
        return await ApiUtils.callApi(`reports/instructor/assignment-sheet/${classId}`,'get');
    }

    async copyOderInstructor(data) {
        return await ApiUtils.callApi(`reports/copy/oder/instructor`,'get', data);
    }

    async downloadCopyOderInstructor(data) {
        return await ApiUtils.callApi(`reports/copy/oder/instructor/download`,'get', data);
    }

    async getInstructorReport(data){
        return await ApiUtils.callApi(`reports/instructor`,'get', data);
    }

    async downloadInstructorReport(data){
        return await ApiUtils.callApi(`reports/instructor/download`,'get', data);
    }

    async getInstructorPayrollReport(data){
        return await ApiUtils.callApi(`reports/instructor/pay-roll`,'get', data);
    }

    async downloadInstructorPayrollReport(data){
        return await ApiUtils.callApi(`reports/instructor/pay-roll/download`,'get', data);
    }

    async downloadInvoiceReport(data){
        return await ApiUtils.callApi(`reports/company/invoice/download`,'get', data);
    }

    async getRevenueReport(data){
        return await ApiUtils.callApi(`reports/company/revenue`,'get', data);
    }
    
    async downloadRevenueReport(data){
        return await ApiUtils.callApi(`reports/company/revenue/download`,'get', data);
    }

    async getWeeklyWorksheet(data){
        return await ApiUtils.callApi(`reports/weekly/worksheet`,'get', data);
    }
    
    async downloadWeeklyWorksheet(data){
        return await ApiUtils.callApi(`reports/weekly/worksheet/download`,'get', data);
    }

    async downloadInstructorClassReport(){
        return await ApiUtils.callApi(`reports/instructor/class/download`,'get');
    }

    async getVideoClicksReport(data) {
        return await ApiUtils.callApi(`reports/video/clicks`, 'get', data);
    }

    async downloadVideoClicksReport(data) {
        return await ApiUtils.callApi(`reports/video/download`, 'get', data);
    }

    async cleanupReport(filePath) {
        return await ApiUtils.callApi(
          'reports/cleanup',
          'post',
          { file_path: filePath }
        );
    }

    async getTeamsVideosList() {
        return await ApiUtils.callApi('teams-videos', 'get');
    }
    
    async updateTeamsVideoWebUrl(id, data) {
        return await ApiUtils.callApi(`teams-videos/${id}/update`, 'post', data);
    }
    
    async deleteTeamsVideo(id) {
        return await ApiUtils.callApi(`teams-videos/${id}`, 'delete');
    }
}